<template>
  <span class="ag-issue"
    @mouseout="mouseoutHandler"
    @mouseover="mouseoverHandler">
    <i v-if="level === 'error'"
      class="pecericon issue-icon"
      :class="issueIcon"
      @click="activeHandler">
    </i>
    <i v-if="level === 'issue'"
      class="pecericon issue-icon"
      :class="issueIcon"
      @click="activeHandler">
    </i>
    <span class="issue-txt">
      <slot></slot>
    </span>
      <s v-show="showTxt"
        class="issue-tip-txt"
        :class="[level, txtToward]"
        :style="{minWidth: tipW+'px'}">
        <em></em>
        <template v-if="curText.length > 1">
          <span v-for="(item, index) in curText"
            :key="index"><del>{{index + 1}}.</del>{{item}}</span>
        </template>
        <span v-else>{{curText[0]}}</span>
      </s>
  </span>
</template>
<script>
export default {
  name: 'az-issue',
  data() {
    return {
      issueIcon: [], // , 'gm-tuoyuan'
      showTxt: false
    };
  },
  props: {
    type: {
      type: String,
      default: 'link' // link, hover
    },
    level: {
      type: String,
      default: 'issue' // issue 疑问，error错误
    },
    to: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: ''
    },
    tipW: {
      type: Number,
      default: 180
    },
    txtToward: {
      type: String,
      default: 'right' // 默认提示的位置，right, left,bottom, top
    }
  },

  computed: {
    curText() {
      if (!this.text) return [];
      return (this.text + '').split('\\r') || [];
    },
    normalIcon() {
      if (this.level == 'error') return 'piecer-waring';
      if (this.level == 'issue') return 'piecer-issue';
      return 'piecer-issue';
    },
    hoverIcon() {
      if (this.level == 'error') return 'piecer-waring-fill';
      if (this.level == 'issue') return 'piecer-issue-fill';
      return 'piecer-issue-fill';
    }
  },
  created() {
    this.issueIcon = [this.normalIcon];
  },
  methods: {
    mouseoverHandler() {
      this.issueIcon = [this.hoverIcon];
      if (this.text) {
        this.showTxt = true;
      }
    },

    mouseoutHandler() {
      this.issueIcon = [this.normalIcon];
      this.showTxt = false;
    },

    activeHandler() {
      if (this.to) {
        window.open(this.to);
      }
    }
  }
};
</script>